import { useEffectOnce } from 'react-use';
import Script from 'next/script';
import { logger } from '@zep/core-logger';
import { Explore } from '../../../components/service/home/Explore';
export const EduTutorialPageView = () => {
  useEffectOnce(() => {
    logger.track('enter_explore');
  });
  return <>
      <Explore isEdu={true} data-sentry-element="Explore" data-sentry-source-file="tutorial-edu.tsx" />
      <Script src="https://www.youtube.com/iframe_api" data-sentry-element="Script" data-sentry-source-file="tutorial-edu.tsx" />
    </>;
};